import { AuthOperation, TenantsOperation } from "@core/types";

export const BLOCK_API_REQUEST_DATA_LIST: Array<AuthOperation | TenantsOperation> = [
    AuthOperation.LOGIN,
    AuthOperation.LOGOUT,
    TenantsOperation.ACCESS_TENANT
];